import React, { useState, useEffect } from 'react';

function Hero() {
  const images = [
    'https://images.unsplash.com/photo-1524593166156-312f362edad0?w=1920&auto=format&fit=crop', // Fighter jet
    'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&auto=format&fit=crop', // Commercial plane in flight
    'https://images.unsplash.com/photo-1502101872923-d48509bff386?w=1920&auto=format&fit=crop', // Plane takeoff
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000); // Faster swipe (4s) for energy
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="hero" id="home">
      <div
        className="hero-background"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      >
        <div className="hero-gradient"></div>
        <div className="hero-overlay">
          <h1>Heifersaero</h1>
          <p>
            Elevating aviation with world-class aeroplane solutions and precision engineering.
          </p>
          <div className="cta-container">
            <a href="/contact" className="cta-button primary">
              Contact Us
            </a>
            <a href="/services" className="cta-button secondary">
              Explore Services
            </a>
          </div>
        </div>
        <div className="hero-indicators">
          {images.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentImage ? 'active' : ''}`}
              onClick={() => setCurrentImage(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;